import React from "react";
import RevenueCommandCenter from "../RevenueCommandCenter/Index";
import NewQualifiedPipeline from "../RepPerformance/NewQualifiedPipelineHTML/NewQualifiedPipeline";
import NewQualifiedPipelinev3 from "../RepPerformance/NewQualifiedPipelineHTML/NewQualifiedPipelinev3";
import { Funnel } from "../EnhancedInsights/Funnel/Funnel";

const HOME_PAGE_REGISTRY = [
  {
    matches: (name) => name === "Revenue Command Center",
    render: () => <RevenueCommandCenter isHome />,
  },
  {
    matches: (name) => name === "New Qualified pipeline",
    render: ({ company }) =>
      company === "C0013" ? <NewQualifiedPipelinev3 /> : <NewQualifiedPipeline />,
  },
  {
    matches: (name, { Win_Rate_Prefix }) =>
      Boolean(Win_Rate_Prefix) &&
      name === `${Win_Rate_Prefix} Cohort Analysis – Closed Deals`,
    render: () => <Funnel isHome />,
  },
];

export const findHomePageEntry = (charts, context) => {
  if (!Array.isArray(charts)) return null;
  for (const chart of charts) {
    const name = chart?.Chart_Name;
    if (!name) continue;
    const entry = HOME_PAGE_REGISTRY.find((e) => e.matches(name, context));
    if (entry) return entry.render(context);
  }
  return null;
};
